/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const airdao_chain_about = () => `AirDAO is a decentralized autonomous organization governing the AMB-NET blockchain and its network of dApps. As the first DAO to encompass an entire L1 blockchain ecosystem, AirDAO is building an integrated suite of digital products and services that strip away the needless complexity from Web3 and bring its benefits to the average consumer via a single, easy-to-use web interface.`
